import { render, staticRenderFns } from "./PanelVideoTeam.vue?vue&type=template&id=f36c8338&"
import script from "./PanelVideoTeam.vue?vue&type=script&lang=js&"
export * from "./PanelVideoTeam.vue?vue&type=script&lang=js&"
import style0 from "./PanelVideoTeam.vue?vue&type=style&index=0&id=f36c8338&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports